/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import classnames from 'classnames';
import Link from 'next/link';

export interface ButtonProps {
  onClick?: () => void;
  variant?:
    | 'secondary'
    | 'primary'
    | 'primary-outline'
    | 'warning'
    | 'destructive'
    | 'signin'
    | 'violet'
    | 'transparent';
  disabled?: boolean;
  type?: 'button' | 'reset' | 'submit';
  loading?: boolean;
  size?: 'small' | 'normal' | 'medium' | 'big' | 'signin';
  isFullWidth?: boolean;
  className?: string;
  ariaLabel: string;
  href?: string;
  children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  type,
  onClick,
  size = 'normal',
  isFullWidth,
  loading,
  className,
  disabled,
  ariaLabel,
  href,
  ...props
}) => {
  const classesButton = classnames({
    'inline-flex items-center rounded focus:outline-none focus:border-accent-blue focus:shadow-outline-indigo transition ease-in-out duration-150':
      true,
    'text-white bg-secondary border border-transparent hover:bg-secondary-dark font-normal':
      variant === 'primary',
      'text-secondary border border-secondary hover:border-secondary-dark hover:text-secondary-dark font-normal':
      variant === 'primary-outline',
    'text-input-text bg-white font-normal border border-input-border hover:border-input-border-hover hover:bg-gray-100/30':
      variant === 'secondary',
    'text-input-text bg-transparent border border-transparent font-normal hover:bg-gray-100':
      variant === 'transparent',
    'text-white bg-primary border border-transparent hover:bg-primary-dark font-normal':
      variant === 'violet',
    'text-white bg-secondary hover:bg-secondary-dark inline-block uppercase font-medium justify-center':
      variant === 'signin',
    'inline-flex justify-center font-normal rounded-lg border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500  sm:w-auto sm:text-sm':
      variant === 'warning',

    'bg-white text-overdue-red border border-overdue-red hover:border-opacity-50 hover:text-opacity-75 ':
      variant === 'destructive',

    'px-2 md:px-4 py-2 text-base leading-6': size === 'normal',
    'px-8 py-4 sm:px-10 md:px-12 lg:px-16 text-xl lg:text-2xl': size === 'big',
    'px-2 md:px-4 py-1 text-sm leading-6': size === 'medium',
    'px-1 md:px-3 py-[2px] text-sm': size === 'small',
    'text-sm px-7 py-3': size === 'signin',
    'w-full justify-center': isFullWidth,
    'opacity-50 cursor-not-allowed': disabled,
    [`${className}`]: className ? true : false,
  });

  if (href) {
    return (
      <Link href={href} className={classesButton} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <button
      aria-label={ariaLabel || 'action button'}
      disabled={disabled || loading}
      onClick={onClick}
      type={type}
      className={classesButton}
    >
      {loading && (
        <img
          src={
            variant === 'secondary' || variant === 'primary-outline'
              ? '/loading-btn-blue.svg'
              : '/loading-btn.svg'
          }
        />
      )}

      {children}
    </button>
  );
};

export default Button;
